export default "__VITE_ASSET__PXJnOzI2__"